import { render, staticRenderFns } from "./IsNotInMySchool.vue?vue&type=template&id=1745a8b4&scoped=true"
import script from "./IsNotInMySchool.vue?vue&type=script&lang=js"
export * from "./IsNotInMySchool.vue?vue&type=script&lang=js"
import style0 from "./IsNotInMySchool.vue?vue&type=style&index=0&id=1745a8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745a8b4",
  null
  
)

export default component.exports